<template>
    <div class="nav">
        <div v-for="(navItem, index) in config.navList" :key="index" class="nav-item">
            <div class="nav-item-title" @click="pageTo(navItem)"
                :class="{ 'active': activeNav == navItem.name, 'title-single': activeNav == '公司简介' }">
                {{ navItem.name }}
            </div>
        </div>
    </div>
</template>

<script>
import { config } from "../js/company";
export default {
    name: 'navMenu',
    props: {
        currentActiveNav: String
    },
    data() {
        return {
            config: config,
            activeNav: this.currentActiveNav
        };
    },
    computed: {
    },
    watch: {
    },
    methods: {
        pageTo(item) {
            this.activeNav = item.name;
            this.$router.push({ name: item.path })
        },
    },
};
</script>

<style scoped lang="less">
.nav {
    display: flex;
    margin-bottom: 125px;

    .nav-item {
        margin-right: 26px;

        .nav-item-title {
            font-size: 20px;

            &:hover {
                cursor: pointer;
            }
        }

        .title-single {
            color: @mainTextColor;
        }

        .active {
            font-weight: 600;
        }
    }
}

@media @mobile {
    .nav {
        display: flex;
        flex-wrap: wrap; // 允许导航项换行
        margin-bottom: 0;
        gap: 16px 20px; // 行内间距+换行间距
        background-color: #575765;
        padding: 16px;
        color: white;

        .nav-item {
            margin-right: 0; // 重置PC端右边距

            .nav-item-title {
                font-size: 14px; // 缩小字号适配移动端
                padding: 4px 0; // 增加点击区域
                white-space: nowrap; // 防止文字换行错乱
            }

            // 保留原有高亮/选中样式，仅适配字号
            .title-single {
                color: white;
            }

            .active {
                font-weight: 600;
                color: #ffee00;
            }
        }
    }
}
</style>
